export default "__VITE_ASSET__47d4a513__"